import React from 'react';
import {inject, observer} from 'mobx-react';
import ReactTooltip from 'react-tooltip';

export default inject('dictStore')(observer(({dictStore: { getLang }}) => (
        <React.Fragment>
            <div
                className="margin-info"
                data-for="tooltip_margin"
                data-tip=""
                data-event="mouseenter click"
            >
                <span className="f-s-ico-info" />
            </div>
            <ReactTooltip
            globalEventOff="click"
            eventOff="mouseleave"
            place="right"
            type={'dark'}
            effect="solid"
            id="tooltip_margin"
            >
            <span>{getLang('EVENTS_WITH_MAXIMUM_COEFFICIENTS_WITHOUT_BOOKMAKER_PROFIT')}</span>
            </ReactTooltip>
       </React.Fragment>
    )),
  );


// WEBPACK FOOTER //
// ./src/components/liveMenu/-MarginInfo/index.jsx